var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTbd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0933,
    r: 18,
    fill: "#D8D8D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.257045
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1143 15.3478H19.5063L19.5737 15.2804V14.1139L19.6412 14.0464H20.4774L20.5448 14.1139V17.5865L20.4774 17.654H19.6412L19.5737 17.5865V16.4268L19.5063 16.3593H16.1143L16.0469 16.2918V15.4153L16.1143 15.3478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5449 20.896V21.7725L20.4774 21.84H16.1144L16.0469 21.7725V20.896L16.1144 20.8286H17.7462L17.8137 20.7611V19.3113L17.7462 19.2439H16.1144L16.0469 19.1765V18.2999L16.1144 18.2324H20.4774L20.5449 18.2999V19.1765L20.4774 19.2439H18.8522L18.7847 19.3113V20.7611L18.8522 20.8286H20.4774L20.5449 20.896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5449 22.651V26.1236L20.4774 26.1911H19.6412L19.5737 26.1236V23.6623L19.5064 23.5949H18.8522L18.7847 23.6623V26.1236L18.7173 26.1911H17.8812L17.8137 26.1236V23.6623L17.7462 23.5949H17.0854L17.018 23.6623V26.1236L16.9506 26.1911H16.1144L16.0469 26.1236V22.651L16.1144 22.5835H20.4774L20.5449 22.651Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0469 27.1626V33.7477L16.3467 34.0478H20.2454L20.5452 33.7477V27.1626H16.0469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7906 14.0464H27.8922L27.5924 14.3465V21.5732L27.2925 21.8732H21.5107V26.1911H27.2925L27.5924 26.4912V33.7476L27.8922 34.0477H31.7906L32.0907 33.7476V14.3465L31.7906 14.0464Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbd);
export default __webpack_public_path__ + "static/media/tbd.6e3e3c63.svg";
export { ForwardRef as ReactComponent };